import {
  SectionContainer,
  SectionTitle,
  SectionTitleBody,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";
import React from "react";
import * as styles from "./SendQuoteSectionIntro.module.scss";
import SendQuoteSectionIntroText from "components/WebQuoteModal/SendQuoteSectionIntro/SendQuoteSectionIntroText";

export const SendQuoteSectionIntro: React.FC = () => {
  return (
    <SectionContainer>
      <SectionTitle variant="wide">
        <SectionTitleHeading className={styles.title}>
          <Trans>Get your summary</Trans>
        </SectionTitleHeading>
        <SectionTitleBody className={styles.introBody}>
          <SendQuoteSectionIntroText
            textAlign="left"
            titleFontSize="inherit"
            contentFontSize="inherit"
          />
        </SectionTitleBody>
      </SectionTitle>
    </SectionContainer>
  );
};
